import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.469 16.1761L16.6465 17.3536L17.3536 16.6465L1.35359 0.646484L0.646484 1.35359L1.59592 2.30303C1.23393 2.57688 1.00004 3.01114 1.00004 3.50004V9.50004C1.00004 10.3285 1.67161 11 2.50004 11H3.00004V13C3.00004 13.4121 3.47042 13.6473 3.80004 13.4L7.00004 11H10.2929L11.2929 12H7.00004V12.5C7.00004 13.3285 7.67161 14 8.50004 14H13.2969L15.469 16.1761ZM7.29293 8.00004L6.29293 7.00004H4.50004C4.2239 7.00004 4.00004 7.2239 4.00004 7.50004C4.00004 7.77618 4.2239 8.00004 4.50004 8.00004H7.29293ZM5.29293 6.00004L4.32458 5.03169C4.13499 5.10275 4.00004 5.28563 4.00004 5.50004C4.00004 5.77618 4.2239 6.00004 4.50004 6.00004H5.29293Z"
      fill="#B3BBCB"
    />
    <path
      d="M17 12.5C17 13.2625 16.4311 13.8921 15.6946 13.9875L13.1153 11.4082C13.6565 10.9496 14 10.265 14 9.50004V6.00004H15.5C16.3285 6.00004 17 6.67161 17 7.50004V12.5Z"
      fill="#B3BBCB"
    />
    <path
      d="M12.4042 10.697C12.7661 10.4232 13 9.98893 13 9.50004V3.50004C13 2.67161 12.3285 2.00004 11.5 2.00004H3.70714L6.70714 5.00004H9.50004C9.77618 5.00004 10 5.2239 10 5.50004C10 5.77618 9.77618 6.00004 9.50004 6.00004H7.70714L8.70715 7.00004L9.37217 7.66506L12.4042 10.697Z"
      fill="#B3BBCB"
    />
  </svg>
);
